export const zhLocale = {
  theme: {
    day: "2025RCEP地方政府",
    title: "暨友城合作(黄山)论坛会议",
    dateline: "已开始",
    unit: "天",
  },
  register: "团组报名",
  activtyTitle: "主要活动",
  activtyTitle2: "参访路线",
  activtyTitle3: "往期回顾",
  iForms: {
    close: "请联系联络人",
    website: "访问网站",
    mainTitle: "2025RCEP地方政府暨友城合作（黄山）论坛",
    register: "批量注册已于2025年5月20日截止",
    back: "返回",
    title: "团组报名页面",
    tellFriend: "告诉朋友",
    STitle: "外事接待",
    eventMessage: "报名方式：",
    InvitationCode: "邀请码：",
    InvitUnitAndPeople: "邀请单位和邀请人",
    teamclass: "团组类别",
    guestType: "团组国别/地区",
    fromWhere: "此行出发地",
    InvitaPlaceHolder: "请输入",
    unitPlaceHolder: "邀请单位",
    peoplePlaceHolder: "邀请人",
    blockName: "团组信息：",
    groupName: "团组名称：",
    persons: "预计团组人数：",
    underTokenPersons: "礼遇标准",
    country: "国别：",

    arriveInfo: "填写抵离信息",
    arriveWay: "抵达方式",
    arrivePlace: "抵达地点",
    departureFlightNumber: "抵达班次",
    arrivalTime: "抵达时间",
    leaveWay: "返程方式",
    leavePlace: "返程地点",
    leaveFlightNumber: "返程班次",
    departureTime: "返程时间",
    attendEvent: "拟出席活动：",
    roomNeed: "用房数量需求",
    roomUnit: "间",
    arrivalInfo: "抵达信息",
    returnInfo: "返程信息",

    attendEvents: {
      label1: "长三角工商青年对话会（合肥）",
      label2: "友城文旅农业合作对话会（合肥）",
      label3: "新能源汽车光伏合作对话会（合肥）",
      label4: "主宾国活动（黄山）",
      label5: "成员国乔裔对话会（合肥）",
      label6: "黄山之夜（合肥）",
    },
    eventClick: "详情",
    visitEvent: "参访意向",
    visitEvents: {
      label1: "皖北行",
      label2: "皖南行",
    },
    contactPerson: "团组对接人：",
    contactWay: "联系方式",
    mainGuests: "主要嘉宾（团长）：",
    otherGuests: "其他嘉宾:",
    guestList: {
      title: "报名截止日期：2025年5月20日23:00",
      smallTitle: "截止日期：2025年5月20日",
      guestType: "团内身份",
      chineseName: "中文姓名",
      englishName: "英文姓名",
      country: "国籍/地区",
      position: "职务",
      department: "单位",
      contact: "联络方式",
      guestLevel: "级别",
      gender: "性别",
      cardType: "证件类型",
      certNumber: "证件号码",
    },
    guestTypeList: {
      leader: "团长",
      vip: "要客",
      normal: "随员",
    },
    activity: {
      name: "活动名称",
      place: "举办地点",
      time: "举办时间",
      action: "详情",
      more: "查看",
    },
    delete: "删除",
    addOthers: "添加团组嘉宾",
    add: "添加",
    activityInfo: "其他信息",
    otherProblem: "其他需求和问题",
    otherProblemPlaceHolder: "多行输入",
    submit: "仅报名",
    cancel: "取消",
    eventMessageSelect: {
      formPeople: "邀请码注册",
      others: "填写邀请方",
    },
    fromWhereSelect: {
      formPeople: "中国大陆境内/Mainland China",
      others: "其它国家或地区/Areas outside Mainland China",
    },
    contactSelect: {
      phone: "中国内地手机号码",
      email: "电子邮件",
      noMessage: "不接收活动信息",
    },
    modalBtn: {
      cancel: "取消",
      confirm: "确定",
    },
    rules: {
      join: "请选择注册方式",
      joinInType: "请输入邀请码",
      teamclass: "请选择团组类别",
      groupName: "请填写团组名称",
      persons: "请填写预计团组人数",
      country: "请填写国别",
      country2: "请选择国籍/地区",
      contactPerson: "请填写团组对接人",
      contactWay: "请填写联系方式",
      chineseName: "请填写中文姓名或英文姓名",
      englishName: "请填写中文姓名或英文姓名",
      position: "请填写职务",
      phone: "请填写正确的手机号",
      email: "请填写正确的邮箱",
      guestType: "请选择嘉宾级别",
      unit: "请填写单位",
      teamType: "请选择团组国别/地区",
      planAttendActivity: "请至少选择一项活动",
      addGroupClass: "请至少添加一名嘉宾",
      underTokenPersons: "请选择礼遇标准",
      InvitUnitAndPeople: "请填写邀请单位和邀请人",
      fromWhere: "请选择出发地",
      selectInviteWay: "请选择邀请方式",
      inviteWay: "邀请方式",
      sendSuccessful: "发送成功",
      gender: "请选择性别",
      male: "男",
      femele: "女",
      cardType: "请选择证件类型",
      certNumber: "请输入证件号码",
    },
    placeholder: {
      teamContactMethod: "手机号码仅限中国大陆地区",
      teamContactMethod2: "电子邮件",
    },
    tableRule: {
      check: "查看",
      edit: "修改",
      delete: "删除",
      action: "操作",
    },
  },
};
